<template>
  <v-card
    :ripple="false"
    class="function-code-block mt-0 pa-0 elevation-0"
    :class="[{isActive : isActive}]"
    @mouseenter="blockOnHover=true"
    @mouseleave="blockOnHover=false"
    @click="$emit('isActive')"
  >
    <v-slide-x-transition>
      <v-tooltip
        v-if="toolbarIsVisible"
        left
      >
        <template v-slot:activator="{on}">
          <v-btn
            x-small
            text
            color="grey"
            fab
            class="move-function-code-block move-icon"
            v-on="on"
          >
            <v-icon>mdi-unfold-more-horizontal</v-icon>
          </v-btn>
        </template>
        Order
      </v-tooltip>
    </v-slide-x-transition>
    <v-row
      v-if="value.cell_type=='markdown' ?_.isEmpty(value.outputs):true"
      class="function-code-block-editor pa-0 pr-3"
    >
      <v-col
        cols="2"
        class="text-right pr-3"
      >
        Entry [{{ value.execution_count }}] :
      </v-col>
      <v-col
        cols="10"
        class="pa-0"
      >
        <editor
          :ref="editorRef"
          v-model="value.source"
          :lang="language"
          theme="chrome"
          class="pa-0"
          width="100%"
          :options="options"
          @init="editorInit"
        />
      </v-col>
    </v-row>
    <v-row
      v-show="!_.isEmpty(value.outputs)"
      class="function-code-block-response"
    >
      <v-col
        cols="2"
        class="text-right"
      >
        Output :
      </v-col>
      <v-col
        class="pa-0 pr-3"
        cols="10"
      >
        <div
          id="result"
          class="pa-0"
          :class="{md : value.cell_type =='markdown','result-success' : !outputsHasError , 'result-error':outputsHasError}"
        >
          <v-btn
            v-if="value.cell_type =='code'"
            id="clearBtn"
            class="absolute"
            x-small
            color="white"
            fab
            text
            @click="clearOutput"
          >
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn>
          <vue-markdown
            v-if="value.cell_type == 'markdown'"
            :source="_.join(value.outputs,'\n')"
            html
            linkify
            emoji
            @dblclick.native="editMarkdown"
          />
          <template v-else>
            <div
              v-if="outputsHasError"
              class="result-overflow"
              v-html="stripAnsi(_.join(_.map(value.outputs,o=> _.join(o.traceback,'') + o.ename + '\n' + o.evalue),''))"
            />
            <template v-else>
              <div
                class="result-overflow"
                v-html="_.join(_.map(value.outputs,o=>{
                  if(o.text)
                    return o.text
                  else if (o.data){
                    if(o.output_type == 'execute_result')
                      return o.data['text/plain']
                    else
                      return `<img src='data:${'image/png'};base64,${o.data['image/png']}' />`
                  }
                }),'')"
              />
            </template>
          </template>
        </div>
      </v-col>
    </v-row>
    <v-progress-linear
      v-if="isExecuting"
      rounded
      indeterminate
      color="cyan"
    />
  </v-card>
</template>

<script>
  import stripAnsi from 'strip-ansi'
  import VueMarkdown from 'vue-markdown'
  export default {
    name: 'FunctionCodeBlock',
    components: {
      'vue-markdown': VueMarkdown,
      'editor': require('vue2-ace-editor-readonly'),
    },
    props: {
      isExecuting: {
        type: Boolean,
        default: false,
      },
      isActive: {
        type: Boolean,
        default: false,
      },
      lang: {
        type: String,
        default: 'PYTHON_3.6',
      },
      value: {
        type: Object,
        default: () => {
          return {
            cell_type: 'code',
            source: '',
            execution_count: 0,
            outputs: [],
            metadata: {},
          }
        },
      },
    },
    data () {
      return {
        editorRef: 'function-code-block-editor-' + _.uniqueId(),
        codeTypeMenuIsVisible: false,
        blockOnHover: false,
        options: {
          fontSize: '10pt',
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: false,
          enableSnippets: true,
          showLineNumbers: true,
          tabSize: 2,
          maxLines: Infinity,
          minLines: 2,
        },
      }
    },
    computed: {
      language () {
        return this.value.cell_type == 'code' ? this.lang.toLowerCase().replace(/[^a-zA-Z ]/g, '') : 'markdown'
      },
      toolbarIsVisible () {
        return this.blockOnHover || this.codeTypeMenuIsVisible
      },
      outputsHasError () {
        return !_.isEmpty(_.filter(this.value.outputs, o => _.has(o, 'traceback')))
      },
    },
    watch: {
      'value.cell_type' (newValue, oldValue) {
        this.value.outputs = []
      },
    },
    mounted () {
      let self = this
      window.addEventListener('keydown', e => {
        if (!this.isActive) { return }
        // Call the "save function" if the user press Ctrl + S (Linux & Windows) or CMD + S (Mac)
        if (e.keyCode == 13 && (window.navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey)) {
          e.preventDefault()
          self.$emit('execute')
        }
      }, false)
    },
    methods: {
      stripAnsi: stripAnsi,
      blobToImg (blob, type) {
        return `<img src='data:${type};base64,${blob}' />`
      },
      clearOutput () {
        this.value.outputs = []
      },
      editMarkdown () {
        if (this.value.cell_type === 'markdown') { this.value.outputs = [] }
      },
      editorInit: function () {
        let editor = this.$refs[this.editorRef].editor
        require('brace/mode/python')
        require('brace/mode/sh')
        require('brace/mode/php')
        require('brace/mode/java')
        require('brace/mode/javascript')
        require('brace/mode/markdown')
        require('brace/mode/ruby')
        require('brace/theme/chrome')
        editor.renderer.setScrollMargin(10, 10, 10, 10)
        editor.setReadOnly(false)
      /*  require('brace/theme/solarized_dark') */
      },
    },
  }
</script>

<style scoped>
.toolbar{
    position:absolute;
    top:10px;
    right:15px;
    z-index:10;
}
.function-code-block-response #result #clearBtn{
    position: absolute;
    top:7px;
    left:-44px;
}
.function-code-block-response #result.md{
    position: relative;
    border-top: none !important;
    border-left: 53px solid #ebebeb !important;
    margin-left: -2px;
}
.function-code-block-response #result{
    height: 100%;
    position: relative;
    border-top: 1px solid transparent;
    border-left: 53px solid transparent;
    margin-left: -2px;
}
.function-code-block-response #result.result-error{
    border-top: 1px solid #ff6b6b;
    border-left: 53px solid #ff6b6b;
    margin-left: -2px;
}
.function-code-block-response #result.result-success{
    border-top: 1px solid #4CAF50 ;
    border-left: 53px solid #4CAF50 ;
    margin-left: -2px;
}

.function-code-block{
    /* border-left: 5px solid transparent !important;
    border: 1px solid transparent; */
    transition:.3s all;
}
.v-card.isActive {
    border-left: 5px solid #73c1ff !important;
    border: 1px solid #73c1ff;
    transition:.3s all;
}
.ace_editor textarea {z-index : 2000 !important;}
.move-icon{
        margin: auto;
    position: absolute;
    left: 5px;
    top: 0;
    bottom: 0;
}
.result-overflow{
    white-space: pre-wrap;
    overflow: auto;
    overflow-x: hidden;
    padding: 10px;
}
</style>
